import { Control, Controller, UseFormSetValue } from "react-hook-form";
import { CartFormValues } from "./types";
import { t } from "i18next";
import React from "react";
import InputBottomSheet from "../../../components/InputBottomSheet";
import { useGetCouponMutation } from "../../../providers/coupons";
import { toast } from "react-toastify";
import { useCartData } from "../../../providers/cartDataStore";

interface CouponBottomSheetProps {
  control: Control<CartFormValues>;
  setValue: UseFormSetValue<CartFormValues>;
}

export const CouponBottomSheet = ({ control, setValue }: CouponBottomSheetProps) => {
  const { applyCoupon } = useCartData();
  const { mutate: getCouponMutation } = useGetCouponMutation();

  const getCoupon = async (code: string) => {
    if (!code) return;

    getCouponMutation(code, {
      onSuccess: async (data) => {
        if (data) {
          applyCoupon(data);
        } else {
          toast.warn(t("Invalid Coupon Code!"));
          setValue("coupon", "");
        }
      },
      onError() {
        toast.warn(t("Invalid Coupon Code!"));
        setValue("coupon", "");
      },
    });
  };

  return (
    <Controller
      name="coupon"
      control={control}
      render={({ field: { onChange, value } }) => (
        <InputBottomSheet
          rows={6}
          value={value}
          title={t("Coupon")}
          inputPlaceholder={t("Enter coupon code")}
          onFooterSaveClickChange={async (value) => {
            onChange(value);
            await getCoupon(value);
          }}
        />
      )}
    />
  );
};
